import { z as zod } from 'zod';
/**
 * zod
 */
export const z = zod;
